import { ColumnSort, SortingState } from '@tanstack/react-table'
import { useEffect, useState } from 'react'
import { KeyAsString } from 'type-fest'

import { dashed } from 'utils/string'
import { SortInputKey, SortProps, UseTableSort } from './types'

const inputToSortingState = <T>(input?: SortInputKey<T>) => {
  const { by, direction } = input || {}

  if (by) {
    return [
      {
        desc: direction === 'desc',
        id: by,
      },
    ]
  } else return []
}

export const useTableSort = <T>(sort?: SortProps<T>): UseTableSort => {
  let initialState: SortingState = []
  if (sort?.input) {
    initialState = inputToSortingState<T>({
      ...sort.input,
      by: dashed(sort.input.by) as KeyAsString<T>,
    })
  }

  let defaultState: SortingState = []
  if (sort?.defaultInput) {
    defaultState = inputToSortingState<T>({
      ...sort.defaultInput,
      by: dashed(sort.defaultInput.by) as KeyAsString<T>,
    })
  }

  const [sorting, setSorting] = useState<SortingState>(initialState)

  useEffect(() => {
    if (sort) {
      if (sorting.length > 0) {
        const { desc, id }: ColumnSort = sorting[0]

        sort.onSort({
          by: id as KeyAsString<T>,
          direction: desc ? 'desc' : 'asc',
        })
      } else {
        setSorting(defaultState)
      }
    }
  }, [sorting])

  return { setSorting, sorting }
}
